import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../i18n/LanguageContext";

const legalSlugs = ["/impressum", "/datenschutz", "/agb", "/einlagensicherung", "/cookies"];

export default function Footer() {
  const { nav, footer } = useContent();
  return (
    <footer className="bg-[#101a2e] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-md bg-white/10 flex items-center justify-center">
                <span className="font-serif-lux text-2xl text-[#d3b077]">B</span>
              </div>
              <div>
                <div className="font-serif-lux text-xl">{nav.brand}</div>
                <div className="text-[10px] tracking-[0.2em] text-white/40">{nav.brandSub}</div>
              </div>
            </div>
            <p className="text-sm text-white/50 leading-relaxed">
              {footer.tagline}
            </p>
          </div>

          <div>
            <div className="text-sm font-semibold text-white/80 mb-4">{footer.navTitle}</div>
            <ul className="space-y-2.5">
              {nav.links.map((l) => (
                <li key={l.label}>
                  <Link to={`/${l.href}`} className="text-sm text-white/50 hover:text-[#d3b077] transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold text-white/80 mb-4">{footer.legalTitle}</div>
            <ul className="space-y-2.5">
              {footer.legalLinks.map((l, i) => (
                <li key={l}><Link to={legalSlugs[i]} className="text-sm text-white/50 hover:text-[#d3b077] transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold text-white/80 mb-4">{footer.contactTitle}</div>
            <ul className="space-y-2.5 text-sm text-white/50">
              {footer.contactLines.map((l) => (<li key={l}>{l}</li>))}
              <li><a href="mailto:info@barlowconsultants.com" className="hover:text-[#d3b077] transition-colors">info@barlowconsultants.com</a></li>
            </ul>

            <div className="text-sm font-semibold text-white/80 mt-6 mb-3">{footer.deOfficeTitle}</div>
            <ul className="space-y-1.5 text-sm text-white/50">
              {footer.deOfficeLines.map((l) => (<li key={l}>{l}</li>))}
              <li><a href="tel:+493082688142" className="hover:text-[#d3b077] transition-colors">+49 30 8268 8142</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Barlow Consultants SL. {footer.rights}</span>
          <span>{footer.disclaimer}</span>
        </div>
      </div>
    </footer>
  );
}
